import http from "utils/http";
import { landingPage } from "constants/endpoints";

const getBookingRequests = () => {
  const ENDPOINT = landingPage.getBookingRequests();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${ENDPOINT}`);
};

export default getBookingRequests;
